import React from 'react';
import { Snackbar as MuiSnackbar, Alert, IconButton, useTheme } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useSnackbarStore } from '../../stores/useSnackbarStore';

const Snackbar: React.FC = () => {
  const theme = useTheme();
  const { open, message, severity, duration, hideSnackbar } = useSnackbarStore();

  return (
    <MuiSnackbar
      open={open}
      autoHideDuration={duration}
      onClose={hideSnackbar}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      sx={{ zIndex: severity === 'error' ? theme.zIndex.tooltip + 2 : undefined }}
    >
      <Alert
        onClose={hideSnackbar}
        severity={severity}
        variant="filled"
        action={
          <IconButton
            size="small"
            aria-label="Dismiss notification"
            onClick={hideSnackbar}
            sx={{ color: 'inherit' }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        }
        sx={{
          width: '100%',
          backgroundColor: theme.palette[severity].main,
          color: theme.palette[severity].contrastText
        }}
      >
        {message}
      </Alert>
    </MuiSnackbar>
  );
};

export default Snackbar;
